/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Maybe } from "~/generated/graphql";

type SpendTreeItem = {
  rawCost: number;
  rawAccumulatedCost?: number;
  accumulatedCost?: string;
  subRows?: SpendTreeItem[];
  parentNid?: Maybe<string>;
  nid: string;
};

export const flatDataToTree = (
  items: SpendTreeItem[],
  nid: string | null = null
): SpendTreeItem[] =>
  items
    .filter((item: SpendTreeItem) => item.parentNid === nid)
    .map((item) => ({
      ...item,
      subRows: flatDataToTree(items, item.nid),
    }));
